import { customAutoCompleteFilter, standardGridPageSize } from "../../../Shared/GlobalVariables/filterVariables";
import reasonsModalController from "./reasonsModal.controller";
import importReasonsModalController from "./importReasonsModal.controller";
import createSpinner from "../../../Shared/Functions/createSpinner";

export default /*@ngInject*/ function ($scope, $uibModal, helperService, reasonsDataService, FileSaver) {

    const vm = this;
    vm.deleteReason = deleteReason;
    vm.openModal = openModal;
    vm.helperService = helperService;
    vm.exportReasons = exportReasons;
    vm.openImportModal = openImportModal;

    activate();

    async function activate() {
        let columnsFromVM = [
            { field: "Name", title: "Reason", filterable: customAutoCompleteFilter },
            { template: `<a ng-click="mrvm.openModal(dataItem)"><i class="fa fa-edit text-warning m-r-xs"></i>Edit</a>`, "title": "Edit", width: 90 },
            { template: `<a ng-click="mrvm.deleteReason(dataItem.Id)"><i class="fa fa-trash-o text-danger m-r-xs"></i>Delete</a>`, "title": "Delete", width: 90 }
        ];

        vm.mainGridOptions = helperService.setMainGridOptions(columnsFromVM, 600);
        vm.mainGridOptions.selectable = false;
    }

    function deleteReason(reason) {
        reasonsDataService.deleteReason(reason)
            .then(response => {
                vm.gridDataSource.read();
            }).catch(errorCallback);
    }

    function errorCallback(response) {
        helperService.showErrorMessage(response.data);
    }

    async function openModal(item) {
        let reasonsModal = $uibModal.open({
            templateUrl: '/App/Components/Certifications/maintainReasons/reasonsModal.html',
            controller: reasonsModalController,
            controllerAs: 'rmvm',
            backdrop: 'static',
            scope: $scope,
            resolve: {
                item: () => item || {}
            }
        });

        try {
            await reasonsModal.result;
            vm.gridDataSource.read();
        } catch {
            return;
        }
    }

    function exportReasons() {

        vm.exportUpdatePending = new createSpinner();

        reasonsDataService.exportReasons()
            .then(response => {
                helperService.successfulSaveButton(vm.exportUpdatePending)
                    .then(result => {
                        FileSaver.saveAs(response.data, 'Reasons-Export.xlsx');
                        vm.exportUpdatePending.loadingValue = false;
                    });
            }).catch(response => {
                helperService.showErrorMessage(response.data);
                vm.exportUpdatePending.loadingValue = false;
            });
    }

    function openImportModal() {
        $uibModal.open({
            templateUrl: '/App/Components/Certifications/maintainReasons/importReasonsModal.html',
            controller: importReasonsModalController,
            controllerAs: 'irvm',
            backdrop: 'static',
            scope: $scope
        });
    }

    vm.gridDataSource = new kendo.data.DataSource({
        pageSize: standardGridPageSize,
        transport: {
            read: async options => {
                try {
                    let response = await reasonsDataService.listReasons();
                    options.success(response.data);
                } catch (error) {
                    options.error(error);
                }
            }
        }
    });

}